import { render, staticRenderFns } from "./settings-account-organization-endpoints.vue?vue&type=template&id=7744aa03&scoped=true&"
import script from "./settings-account-organization-endpoints.vue?vue&type=script&lang=js&"
export * from "./settings-account-organization-endpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7744aa03",
  null
  
)

export default component.exports